import { Spacing } from '@zep/ui';
import { usePlanStatusType } from '../hooks';
import { usePlanPaymentFormContext, usePlanPaymentInfoContext } from '../PlanPaymentSection/Providers';
import { PlanTemplateType } from '../types';
import { PlanDurationDetails } from './PlanDurationDetails';
import { PlanNotifications } from './PlanNotifications';
import { PlanStepBreadCrumbs } from './PlanStepBreadCrumbs';
import { PlanTermsAgreement } from './PlanTermsAgreement';
import { PleaseContact } from './PleaseContact';
import { PriceInfo } from './PriceInfo';
import { SelectedPlanInfo } from './SelectedPlanInfo';
import { SpaceInfoSection } from './SpaceInfoSection';
export const PlanPaymentSummary = () => {
  const {
    watch
  } = usePlanPaymentFormContext();
  const {
    isUpdate
  } = usePlanPaymentInfoContext();
  const planType = watch('planType');
  const maxCcu = watch('maxCcu');
  const planTemplateType = watch('planTemplateType');
  const onetimePeriod = watch('onetimePeriod');
  const planStatusType = usePlanStatusType({
    planType
  });
  const showContactInfo = planType === 'enterprise' || !!maxCcu && maxCcu >= 300 && planTemplateType === PlanTemplateType.PRODUCT_SUBSCRIPTION || onetimePeriod === undefined && planTemplateType === PlanTemplateType.PRODUCT_ONETIME;
  return <div className="sticky top-[64px] h-full flex-1 bg-gray-100 px-[50px] pb-[130px] pt-[40px]" data-sentry-component="PlanPaymentSummary" data-sentry-source-file="PlanPaymentSummary.tsx">
      <div className="w-[320px] max-w-[320px]">
        <PlanStepBreadCrumbs data-sentry-element="PlanStepBreadCrumbs" data-sentry-source-file="PlanPaymentSummary.tsx" />
        <Spacing size={18} data-sentry-element="Spacing" data-sentry-source-file="PlanPaymentSummary.tsx" />
        <div className="overflow-hidden rounded-[10px] border border-[#27262E14] shadow-[0_1px_4px_0_rgba(42,49,65,0.08)]">
          <SpaceInfoSection data-sentry-element="SpaceInfoSection" data-sentry-source-file="PlanPaymentSummary.tsx" />
          {showContactInfo ? <PleaseContact /> : <>
              {planStatusType !== 'SAME_GRADE' && <SelectedPlanInfo />}
              <PriceInfo />
            </>}
        </div>
        {!showContactInfo && <>
            {!(planStatusType === 'SAME_GRADE' && isUpdate) && <>
                <Spacing size={10} />
                <PlanDurationDetails />
              </>}
            <Spacing size={10} />
            <PlanNotifications />
            <PlanTermsAgreement />
          </>}
      </div>
    </div>;
};